import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";

const GroupModal = ({
  show,
  handleClose,
  row,
  handleGroupChange,
  manadalId,
}) => {
  const apiURL = process.env.REACT_APP_API_URL;
  const [assignedData, setAssignedData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [isRemoveButtonShow, setIsRemoveButtonShow] = useState(false);
  const [removeButtonMap, setRemoveButtonMap] = useState({});
  const [loading, setLoading] = useState(null);

  // Fetch group data when the modal opens
  useEffect(() => {
    if (show) {
      fetchGroupData();
    }
  }, [show]);

  useEffect(() => {
    fetchAssignedGroupData();
  }, [show, handleGroupChange]);

  useEffect(() => {
    if (show && row && groupData.length && assignedData.length) {
      buildRemoveButtonMap(groupData, assignedData);  
    }
  }, [show, row, groupData, assignedData, handleGroupChange]);

  const fetchAssignedGroupData = async () => {
    try {
      const response = await axios.get(
        `${apiURL}/GroupDetails/Get?mandalDetailsId=${manadalId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = response?.data?.data;

      setAssignedData(data);
      console.log(`assigned data: ${JSON.stringify(assignedData)}`);
    } catch (error) {
      console.log(error?.response.data.data);
    }
  };

  const fetchGroupData = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(`${apiURL}/SamparkEmploye/Get`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const filteredData = response.data.data.filter(
        (item) => item.mandalDetailsId === manadalId
      );

      // Ensure uniqueness using a Map (based on employee ID)
      setGroupData((prev) => {
        const uniqueGroups = [...prev, ...filteredData].reduce((acc, group) => {
          acc.set(group.id, group);
          return acc;
        }, new Map());
        return Array.from(uniqueGroups.values());
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "Error fetching group data");
    }
  };

  const buildRemoveButtonMap = (groups, assignedData) => {
    if (!row) return;
    const map = {};

    groups.forEach((group) => {
      const isAssigned = assignedData.some(
        (item) =>
          row.id === item.haribhaktId &&
          row.mandalDetailsId === item.mandalDetailsId &&
          group.id === item.samparkEmployeId
      );
      map[group.id] = isAssigned;
    });

    setRemoveButtonMap(map);
  };

  const handleAddToGroup = (groupId) => {
    console.log(`groupId: ${groupId}`);

    if (!row || !row.mandalDetailsId) {
      console.error(
        "Row data is missing or does not contain mandalDetailsId",
        row
      );
      toast.error("Failed to assign group. Missing data!");
      return;
    }

    setLoading(groupId);

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiURL}/GroupDetails/Create?mandalDetailsId=${row.mandalDetailsId}&haribhaktId=${row.id}&samparkEmployeId=${groupId}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data?.status) {
          handleGroupChange(groupId);
          toast.success("Successfully assigned to the group! 🎉");
        } else {
          toast.error(response.data?.message || "Failed to assign group!");
        }
        fetchAssignedGroupData();
      })
      .catch((error) => {
        console.error("Error adding to group:", error);
        toast.error(error.response?.data?.message || "Something went wrong!");
      })
      .finally(() => {
        setLoading(null);
      });
  };

  const handleRemoveFromGroup = async (groupId) => {
    try {
      let fetchedId;
  
      console.log("🔍 Starting removal...");
      console.log("📦 groupId passed:", groupId);
      console.log("📄 row object:", row);
      console.log("📋 assignedData:", JSON.stringify(assignedData));
  
      assignedData.filter((item) => {
        console.log("🔎 Checking item:", item);
        const isMatch =
          row.id === item.haribhaktId &&
          row.mandalDetailsId === item.mandalDetailsId &&
          groupId === item.samparkEmployeId;
  
        console.log(`✅ Match status: ${isMatch}`);
  
        if (isMatch) {
          fetchedId = item.id;
          console.log("🎯 Matched item ID (fetchedId):", fetchedId);
        }
      });
  
      if (!fetchedId) {
        console.warn("⚠️ No matching item found to delete.");
        return;
      }
  
      console.log(`🚀 Sending DELETE request to: ${apiURL}/GroupDetails/Delete?id=${fetchedId}`);
  
      const response = await axios.delete(
        `${apiURL}/GroupDetails/Delete?id=${fetchedId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
  
      toast.success(response?.data?.message);
      console.log("✅ Deleted successfully:", response?.data);
      fetchAssignedGroupData();
    } catch (error) {
      console.error("❌ Error in deletion:", error?.response?.data?.data || error);
    }
  };
  

  return (
    <div
      className={`modal fade ${show ? "show" : ""}`}
      style={{ display: show ? "block" : "none" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Assign Group</h5>
            <button
              type="button"
              className="btn btn-sm btn-transperent btn-danger"
              aria-label="Close"
              onClick={handleClose}
            >
              <FaTimes size={20} />
            </button>
          </div>
          <div className="modal-body">
            <h6>
              Select a group to add {row?.firstName} {row?.lastName}{" "}
              {row?.surName} to:
            </h6>
            <ul className="list-group">
              {groupData.map((group) => (
                <li
                  key={group.id}
                  className="list-group-item d-flex justify-content-between"
                >
                  {group.firstName} {group.lastName} {group.surName}
                  <div className="d-flex">
                    <button
                      className="btn btn-primary mr-2"
                      onClick={() => handleAddToGroup(group.id)}
                      disabled={loading === group.id}
                    >
                      {loading === group.id ? "Assigning..." : "Assign Group"}
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={() => handleRemoveFromGroup(group.id)}
                      disabled={
                        loading === group.id || !removeButtonMap[group.id]
                      }
                    >
                      {loading === group.id ? "Removing..." : "Remove"}
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupModal;
